import { U2bColumnPipeName, U2bTableData } from '@core/components/layout/table/table.types';
import { BcmUserTableSettingKey } from '@shared/models/bcm-settings-user';
import { getIsActive } from '@core/functions/get-is-active';
import { BcmVoucherDto } from '@shared/models/bcm-voucher';
import { FilterFieldType } from '@core/datafilter/available-filter-fields';

export const vouchersTableData: U2bTableData = {
    tableId: BcmUserTableSettingKey.Vouchers,
    hasServerSideFiltering: true,
    columnDefinitions: [
        {
            property: 'id',
            name: 'ID',
            isActive: getIsActive(),
            translationKey: 'bcmVouchers.table.id',
            filter: {}
        },
        {
            property: 'title',
            name: 'Gutschein',
            isActive: getIsActive(),
            translationKey: 'bcmVouchers.table.title',
            filter: {}
        },
        {
            property: 'quantityTotal',
            name: 'Menge<br>(gesamt)',
            isActive: getIsActive(),
            pipe: U2bColumnPipeName.Decimal,
            translationKey: 'bcmVouchers.table.quantityTotal',
            filter: {
                fieldType: FilterFieldType.Numeric
            }
        },
        {
            property: 'quantityLeft',
            name: 'Menge<br>(verbleibend)',
            isActive: getIsActive(),
            pipe: U2bColumnPipeName.Decimal,
            translationKey: 'bcmVouchers.table.quantityLeft',
            filter: {
                fieldType: FilterFieldType.Numeric
            }
        },
        {
            property: 'totalPrice',
            name: 'Preis',
            isActive: getIsActive(),
            pipe: U2bColumnPipeName.Currency,
            translationKey: 'bcmVouchers.table.totalPrice',
            exportFormat: '#,##0.00 €',
            filter: {
                fieldType: FilterFieldType.Numeric
            }
        },
        {
            property: 'validFrom',
            name: 'Gültig<br>von',
            isActive: getIsActive(),
            translationKey: 'bcmVouchers.table.validFrom',
            pipe: U2bColumnPipeName.Date,
            exportFormat: 'DD.MM.YYYY',
            filter: {
                fieldType: FilterFieldType.Date
            }
        },
        {
            property: 'validUntil',
            name: 'Gültig<br>bis',
            isActive: getIsActive(),
            translationKey: 'bcmVouchers.table.validUntil',
            pipe: U2bColumnPipeName.Date,
            exportFormat: 'DD.MM.YYYY',
            filter: {
                fieldType: FilterFieldType.Date
            }
        },
        {
            property: 'productTaxRate',
            name: 'Steuer&shy;satz',
            translationKey: 'table.taxRate',
            isActive: getIsActive(false, false, false),
            exportKey: 'product.taxRate.value',
            parseItem: (item: BcmVoucherDto) => item.product?.taxRate?.value || 0,
            pipe: U2bColumnPipeName.Percent,
            filter: {}
        },
        {
            property: 'productPrice',
            name: '',
            isActive: getIsActive(false, false, false),
            translationKey: 'bcmVouchers.table.productPrice',
            exportKey: 'product.price',
            parseItem: (item: BcmVoucherDto) => item.product.price || 0,
            pipe: U2bColumnPipeName.Currency,
            exportFormat: '#,##0.00 €',
            filter: {
                fieldType: FilterFieldType.Numeric,
                property: 'product.price',
            }
        },
    ],
};
